/* Collection and opted-in homepage card colour previews. No library, catalogue fetch, eager prefetch or DOM observer. */
(function () {
  'use strict';
  if (window.__mipColourPreviewInstalled) return;
  window.__mipColourPreviewInstalled = true;
  var hover = window.matchMedia('(hover: hover) and (pointer: fine)');
  var selector = '.collection-default[data-mip-colour-hover="true"] #CollectionProductGrid .pc-color-swatch[data-pc-preview-image], .pc-premium[data-pc-colour-hover="true"] .pc-color-swatch[data-pc-preview-image]';
  var cache = new Map(); // In-flight images only; browser HTTP cache handles subsequent loads.
  var active = null;
  var timer = null;
  var leaveTimer = null;
  var sequence = 0;

  function find(target) { return target && target.closest ? target.closest(selector) : null; }
  function clearLeave() { clearTimeout(leaveTimer); leaveTimer = null; }
  function cancelPending() {
    clearTimeout(timer); timer = null; sequence += 1;
    if (active) active.pending = null;
  }
  function restore() {
    clearLeave(); cancelPending();
    if (!active) return;
    active.card.classList.remove('pc-colour-preview-active');
    if (active.shown) active.shown.classList.remove('is-previewing');
    if (active.image) active.image.remove();
    active = null;
  }
  function scheduleLeave() {
    // A fractional-pixel boundary crossing must not make the photograph flash.
    // Invalidate pending work now so an image cannot arrive after leaving the card.
    clearLeave(); cancelPending();
    leaveTimer = setTimeout(restore, 150);
  }
  function sizedURL(swatch, media) {
    try {
      var url = new URL(swatch.dataset.pcPreviewImage, location.origin);
      if (!/^https?:$/.test(url.protocol)) return null;
      var width = Math.ceil(media.getBoundingClientRect().width * Math.min(window.devicePixelRatio || 1, 2));
      var target = width <= 320 ? 320 : width <= 480 ? 480 : width <= 640 ? 640 : width <= 960 ? 960 : 1280;
      // Source URLs are existing Shopify image_url outputs, not catalogue endpoints.
      url.searchParams.set('width', String(target));
      return url.href;
    } catch (ignore) { return null; }
  }
  function prepared(url) {
    if (cache.has(url)) return cache.get(url);
    var promise = new Promise(function (resolve, reject) {
      var image = new Image();
      image.decoding = 'async';
      // This is a user-requested preview, not a speculative high-priority preload.
      image.fetchPriority = 'auto';
      var settled = false;
      var timeout = setTimeout(function () {
        finish(new Error('Colour image request timed out'));
        image.removeAttribute('src');
      }, 12000);
      function finish(error) {
        if (settled) return;
        settled = true; clearTimeout(timeout);
        image.onload = null; image.onerror = null;
        if (error) reject(error); else resolve(image);
      }
      image.onload = function () {
        var ready;
        try { ready = image.decode ? image.decode() : Promise.resolve(); }
        catch (ignore) { ready = Promise.resolve(); }
        Promise.resolve(ready).then(function () {
          finish(image.naturalWidth ? null : new Error('Colour image is empty'));
        }, function () {
          finish(image.naturalWidth ? null : new Error('Colour image could not be decoded'));
        });
      };
      image.onerror = function () { finish(new Error('Colour image could not be loaded')); };
      image.src = url;
    });
    cache.set(url, promise);
    var release = function () { if (cache.get(url) === promise) cache.delete(url); };
    promise.then(release, release);
    while (cache.size > 24) cache.delete(cache.keys().next().value);
    return promise;
  }
  function preview(swatch) {
    clearLeave();
    var card = swatch.closest('.pc-premium');
    var media = card && card.querySelector('.pc-media');
    if (!card || !media || !swatch.isConnected || card.closest('.is-dragging')) return;
    if (document.querySelector('dialog[open], [data-mip-filter-popover]:not([hidden]), [data-mip-region-open]')) return;
    if (active && active.card !== card) restore();
    var url = sizedURL(swatch, media);
    if (!url) { restore(); return; }
    if (active && active.pending === swatch) return;
    cancelPending();
    if (!active) active = { card: card, media: media, shown: null, image: null, pending: null };
    // Returning to the already displayed colour cancels a different pending colour
    // without removing or requesting the displayed image a second time.
    if (active.shown === swatch && active.image) return;
    var state = active;
    state.pending = swatch;
    var request = sequence;
    // The previously displayed image stays visible throughout this wait/download.
    timer = setTimeout(function () {
      timer = null;
      prepared(url).then(function (image) {
        if (request !== sequence || active !== state || state.pending !== swatch || !card.isConnected || !swatch.isConnected) return;
        if (!swatch.matches(selector)) { restore(); return; }
        image.className = 'pc-colour-preview-image';
        image.alt = swatch.dataset.pcPreviewAlt || swatch.getAttribute('aria-label') || '';
        // The exact decoded node is inserted; one synchronous swap, not two layers
        // blending together and not a second duplicate request for the same photo.
        if (state.image) state.image.replaceWith(image);
        else media.appendChild(image);
        if (state.shown) state.shown.classList.remove('is-previewing');
        state.image = image; state.shown = swatch; state.pending = null;
        card.classList.add('pc-colour-preview-active');
        swatch.classList.add('is-previewing');
      }).catch(function () {
        if (request !== sequence || active !== state) return;
        state.pending = null;
        // A failed image must not blank the card. Keep its last working photograph
        // (or the native image on the first attempt); another hover can retry.
        if (!state.image) restore();
      });
    }, 90);
  }
  document.addEventListener('pointerover', function (event) {
    if (!hover.matches || event.pointerType === 'touch') return;
    if (active && active.card.contains(event.target)) clearLeave();
    var swatch = find(event.target);
    if (swatch && (!event.relatedTarget || !swatch.contains(event.relatedTarget))) preview(swatch);
    else if (active && event.target.closest) {
      var emptySwatch = event.target.closest('a.pc-color-swatch');
      // Do not keep another colour selected over a swatch with no usable photo.
      if (emptySwatch && active.card.contains(emptySwatch) && !find(emptySwatch)) restore();
    }
  });
  document.addEventListener('pointerout', function (event) {
    if (!active || event.pointerType === 'touch' || !active.card.contains(event.target)) return;
    if (event.relatedTarget && active.card.contains(event.relatedTarget)) return;
    // Hold a preview while moving between colours or onto this card's main image;
    // normal second-image hover resumes only when the whole card has been left.
    scheduleLeave();
  });
  document.addEventListener('pointerdown', function (event) {
    if (event.pointerType === 'touch') restore();
  }, { passive: true });
  document.addEventListener('focusin', function (event) {
    var swatch = find(event.target);
    if (swatch && swatch.matches(':focus-visible')) preview(swatch);
  });
  document.addEventListener('focusout', function (event) {
    if (!active || !active.card.contains(event.target)) return;
    if (event.relatedTarget && active.card.contains(event.relatedTarget)) return;
    scheduleLeave();
  });
  document.addEventListener('keydown', function (event) { if (event.key === 'Escape') restore(); });
  document.addEventListener('mip:collection:loading', restore);
  document.addEventListener('mip:collection:updated', restore);
  document.addEventListener('shopify:section:unload', restore);
  document.addEventListener('visibilitychange', function () { if (document.hidden) restore(); });
  // Release a carousel preview if its track moves; do not leave a colour pinned
  // to a card which has scrolled away or is moving under the pointer.
  window.addEventListener('scroll', function (event) {
    if (!active || !active.card.hasAttribute('data-pc-colour-hover')) return;
    var target = event.target;
    if (target === document || target === window || (target && target.contains && target.contains(active.card))) restore();
  }, { passive: true, capture: true });
  window.addEventListener('resize', restore, { passive: true });
  document.addEventListener('mip:surface:open', restore);
  window.addEventListener('pagehide', restore);
  window.addEventListener('blur', restore);
  function capabilityChanged() { if (!hover.matches) restore(); }
  if (hover.addEventListener) hover.addEventListener('change', capabilityChanged);
  else if (hover.addListener) hover.addListener(capabilityChanged);
  // All original hrefs, normal/modified clicks and mobile taps remain untouched.
})();
